import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutUs from "./pages/AboutUs";
import CrushCoffee from "./pages/CrushCoffee";
import Contact from "./pages/Contact";
import Tours from "./pages/Tours";
import { Box } from "@mui/material";

function App() {
  return (
    <Router>
      <Box sx={{ overflowX: "hidden" }}>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/crush-coffee" element={<CrushCoffee />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/tours" element={<Tours />} />
        </Routes>
        <Footer />
      </Box>
    </Router>
  );
}

export default App;
